// extracted by mini-css-extract-plugin
export default {"modal":"xC-z","sharingIconsV2":"yC-z","notificationBox":"zC-z","checkMark":"AC-z","textFrame":"BC-z"};